// extracted by mini-css-extract-plugin
export var callCard = "_qw-0";
export var callMessageButton = "_qw-1";
export var helpIcon = "_qw-3";
export var helpIconContainer = "_qw-4";
export var verticalDivider = "_qw-2";